import request from '@/utils/request';

export function fetchList(query) {
    return request({
        url: 'https://viaglobal.pl/api//reports',
        method: 'get',
        params: query,
    });
}

export function fetchReport(id) {
    return request({
        url: 'https://viaglobal.pl/api//reports/' + id,
        method: 'get',
    });
}


export function createReport(data) {
    return request({
        url: 'https://viaglobal.pl/api//reports',
        method: 'post',
        data,
    });
}

export function storeReportComment(data) {
    return request({
        url: 'https://viaglobal.pl/api//reports-comment',
        method: 'post',
        data,
    });
}

export function updateReport(data) {
    return request({
        url: 'https://viaglobal.pl/api//reports/' + data.id,
        method: 'put',
        data,
    });
}

export function deleteReport(data) {
    return request({
        url: 'https://viaglobal.pl/api//reports/' + data.id,
        method: 'delete',
        data,
    });
}


